<iframe
  *ngIf="!isLoading"
  [class.splitscreen]="splitscreen"
  [class.navBarPresent]="!openFromBooth"
  [class.openFromBooth]="openFromBooth"
  [src]="url | safe"
  allow="camera *; microphone *; display-capture *;"
  allowfullscreen
  class="bbb"
  id="wait"
  name="wait"
  sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin allow-popups allow-downloads"
></iframe>
<mat-spinner id="some" *ngIf="isLoading"></mat-spinner>
<iframe
  *ngIf="splitscreen && room.splitscreen && room.splitscreen.enabled && room.splitscreen.tool === SplitscreenTool.iFrame"
  allow="camera *; microphone *; display-capture *;"
  allowfullscreen
  sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin allow-popups allow-downloads"
  [src]="room.splitscreen.content | safe"
  class="splitscreen splitscreen-mobile"
></iframe>
<div
  (click)="toggleSplitscreen()"
  *ngIf="room.splitscreen && room.splitscreen.enabled"
  class="btn-splitscreen"
  matTooltip="Activate Splitscreen"
>
  <svg id="Layer_1" version="1.1" viewBox="0 0 206.267 206.267" x="0px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px">
    <g>
      <path
        d="M87.267,23.8h-83.3C1.774,23.8,0,25.574,0,27.768v150.733c0,2.192,1.774,3.967,3.967,3.967h83.3
            c2.192,0,3.967-1.774,3.967-3.967V27.768C91.233,25.574,89.459,23.8,87.267,23.8z M83.3,174.534H7.933v-142.8H83.3V174.534z"
      />
      <path
        d="M202.3,23.8H119c-2.192,0-3.967,1.774-3.967,3.967v150.733c0,2.192,1.774,3.967,3.967,3.967h83.3
            c2.192,0,3.967-1.774,3.967-3.967V27.768C206.267,25.574,204.492,23.8,202.3,23.8z M198.333,174.534h-75.367v-142.8h75.367
            V174.534z"
      />
      <rect height="190.4" width="7.933" x="99.167" y="7.933" />
      <rect height="7.933" width="11.9" x="126.933" y="162.633" />
      <rect height="7.933" width="11.9" x="134.867" y="146.767" />
      <rect height="7.933" width="11.9" x="142.8" y="162.633" />
      <rect height="7.933" width="11.9" x="150.733" y="146.767" />
      <rect height="7.933" width="11.9" x="158.667" y="162.633" />
      <rect height="7.933" width="11.9" x="166.6" y="146.767" />
      <rect height="7.933" width="11.9" x="174.533" y="162.633" />
      <rect height="7.933" width="11.9" x="182.467" y="146.767" />
      <rect height="7.933" width="11.9" x="126.933" y="130.9" />
      <rect height="7.933" width="11.9" x="142.8" y="130.9" />
      <rect height="7.933" width="11.9" x="158.667" y="130.9" />
      <rect height="7.933" width="11.9" x="174.533" y="130.9" />
      <rect height="7.933" width="11.9" x="134.867" y="115.034" />
      <rect height="7.933" width="11.9" x="150.733" y="115.034" />
      <rect height="7.933" width="11.9" x="166.6" y="115.034" />
      <rect height="7.933" width="11.9" x="182.467" y="115.034" />
      <rect height="7.933" width="11.9" x="126.933" y="99.167" />
      <rect height="7.933" width="11.9" x="142.8" y="99.167" />
      <rect height="7.933" width="11.9" x="158.667" y="99.167" />
      <rect height="7.933" width="11.9" x="174.533" y="99.167" />
      <rect height="7.933" width="11.9" x="134.867" y="83.3" />
      <rect height="7.933" width="11.9" x="150.733" y="83.3" />
      <rect height="7.933" width="11.9" x="166.6" y="83.3" />
      <rect height="7.933" width="11.9" x="182.467" y="83.3" />
      <rect height="7.933" width="11.9" x="126.933" y="67.433" />
      <rect height="7.933" width="11.9" x="142.8" y="67.433" />
      <rect height="7.933" width="11.9" x="158.667" y="67.433" />
      <rect height="7.933" width="11.9" x="174.533" y="67.433" />
      <rect height="7.933" width="11.9" x="134.867" y="51.568" />
      <rect height="7.933" width="11.9" x="150.733" y="51.568" />
      <rect height="7.933" width="11.9" x="166.6" y="51.568" />
      <rect height="7.933" width="11.9" x="182.467" y="51.568" />
      <rect height="7.933" width="11.9" x="126.933" y="35.701" />
      <rect height="7.933" width="11.9" x="142.8" y="35.701" />
      <rect height="7.933" width="11.9" x="158.667" y="35.701" />
      <rect height="7.933" width="11.9" x="174.533" y="35.701" />
    </g>
  </svg>
</div>
